<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VH7KwA/tc-custom/9781429966436.jpg?1730984880480" alt="This image is the cover for the book Elysian Fields, Sentinels of New Orleans"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Elysian Fields, Sentinels of New Orleans
      </h1>
      <p class="bookDescription body article font2">
        <b>A necromancer dredges up a historic terror in this urban fantasy thriller set in post-Katrina New Orleans.</b><br/><br/>New Orleanians are under attack from an undead serial killer. The Axeman of New Orleans was supposed to have claimed his last victim in 1919—so what’s he doing stalking the streets now? A tip from the undead pirate Jean Lafitte leads DJ Jaco to the unknown necromancer behind the Axeman’s resurrection. And his ultimate target is a certain blonde wizard. Namely, DJ.<br/><br/>Getting the Axeman back in his grave isn’t easy—especially when DJ has more trouble piling up around her. Jake Warin’s loup-garou nature is spiraling downward, enigmatic neighbor Quince Randolph is acting weirder than ever, the Elders are insisting on lessons in elven magic from the world’s most annoying wizard, and former partner Alex Warin just turned up on DJ’s to-do list. Not to mention big maneuvers are afoot in the halls of preternatural power.<br/><br/>Suddenly, moving to the Beyond as Jean Lafitte’s pirate wench could be DJ’s best option.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Suzanne Johnson
      </h2>
      
      <p class="authorDescription body article"><P>SUZANNE JOHNSON is a magazine editor and feature writer with more than fifty national writing and editing awards. A longtime New Orleans resident, she helped rebuild for two years after Hurricane Katrina. <I>Royal Street</I> was her first novel and is the first book in an urban fantasy series about the Sentinels of New Orleans, wizards who guard the storied city against preternatural dangers.  As Susannah Sandlin, Suzanne is also the author of The Penton Vampire Legacy, a series of popular paranormal romances.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5ff60b87